var map = {
	"./bank.png": 25626,
	"./beauty.png": 24795,
	"./catering.png": 88565,
	"./leisure.png": 53660,
	"./other.png": 39467,
	"./service.png": 17338,
	"./shopping.png": 17435,
	"assets/brands/bank.png": 25626,
	"assets/brands/beauty.png": 24795,
	"assets/brands/catering.png": 88565,
	"assets/brands/leisure.png": 53660,
	"assets/brands/other.png": 39467,
	"assets/brands/service.png": 17338,
	"assets/brands/shopping.png": 17435
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50722;